<h1>Success Verify {{username}}!</h1>
<h2>Click '<a href="/login">here</a>' to Login</h2>
